/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 16,
        height: 18,
        viewBox: "0 0 16 18",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M11.44 3.06q-.1-.04-.13-.15a2.6 2.6 0 0 0-1.7-1.6C8.7 1 7.77.96 6.82 1.03c-.63.05-1.26.14-1.85.4-.79.33-1.36.86-1.47 1.76q-.13 1.19.84 1.88.28.2.58.33c.17.09.35.17.46.34q.1.1.29.12c1.12.1 2.21.36 3.3.63.7.17 1.4.4 2 .79a2.5 2.5 0 0 1 1.21 2.4 2.2 2.2 0 0 1-1 1.81q-.41.27-.9.36a1 1 0 0 0-.56.3",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M5.47 5.86c-.2.18-.44.26-.7.32-.9.21-1.59.7-1.8 1.66-.24 1.08-.01 2.02.93 2.72.54.4 1.15.65 1.79.84q.97.27 1.94.48c.63.15 1.27.22 1.9.32q.15-.02.22.1c.13.2.34.28.53.38.52.27.99.6 1.18 1.18q.4 1.14-.4 2.05c-.5.55-1.15.8-1.84.93q-1.62.33-3.25-.01c-.8-.18-1.51-.53-1.97-1.26q-.15-.23-.24-.48a.2.2 0 0 0-.12-.16",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            })
        ]
    }));
};
export default SvgComponent;
